<div class="page-not-found">
  <img src="/assets/svg/loupe-404.svg" alt="" />
  <h1>
    We’re sorry, but the page you’re trying to access is either unavailable or
    you may not have the necessary permissions to view it.
  </h1>
  <a [routerLink]="['/deal']">Go to Deals →</a>
</div>
